// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_social-media-templates_btn-primary__3HCfz","save-btn":"_social-media-templates_save-btn__xkZPP","coming-soon":"_social-media-templates_coming-soon__1e5kf"};